module.exports = __webpack_public_path__ + "static/media/KAPorg-white.be01ad52.svg";